// extracted by mini-css-extract-plugin
export var dividerLine = "_3o-0";
export var errorBackground = "_3o-1";